import { v4 as uuidv4 } from "uuid";

export const queued = [];
export let paused = false;

export const NotificationEvent = Object.freeze({
  ADD: "addNotification",
  DELETE: "deleteNotification"
});

export const publishNotification = options => {
  const event = new CustomEvent(NotificationEvent.ADD, {
    detail: {
      message: options.message,
      variant: options.level,
      sticky: options.sticky,
      html: options.html,
      onClose: options.onClose,
      id: options.id || uuidv4()
    }
  });
  document.dispatchEvent(event);
  return event.detail.id;
};

export const show = function show(options) {
  return publishNotification(options);
};

export const hide = function hide(notificationId) {
  const event = new CustomEvent(NotificationEvent.DELETE, {
    detail: { id: notificationId }
  });
  document.dispatchEvent(event);
};

const notificationContainerClass = ".notification-container";

export const areNotificationsShown = () =>
  document.querySelector(notificationContainerClass)?.hasChildNodes();

export const queue = function queue(options) {
  queued.push(options);
};

export const dequeue = function dequeue() {
  setTimeout(() => {
    if (queued.length && !areNotificationsShown() && !paused) {
      show(queued.shift());
    }
  }, 1000);
};

export const pauseMessagesQueue = function pauseMessagesQueue(pause) {
  paused = pause;
  if (!paused) dequeue();
};
